const red = '#c60';
const green = '#6c0';
const black = '#000';
const gray = '#ddd';
const darkGray = '#999';

export default {
    red,
    green,
    black,
    gray,
    darkGray
};
